export const onResetQuiz = state => {
  return {
    ...state,
    current: {
      quiz: state.quizzes[0].id,
      question: state.quizzes[0].questions[0].id
    },
    answers: [],
    answer: []
  };
};
